<itfg-dashboard>
  <!-- Profile/Welcome Box -->
  <itfg-d-box title="" [colSpan]="3">
    @if (currentlyLoggedOperator && loginHistory && loginHistoryFromDate) {
      <div
        >
        <itfg-welcome
          [operator]="currentlyLoggedOperator"
          [loginHistory]="loginHistory"
          [loginHistoryFromDate]="loginHistoryFromDate | date: 'mediumDate'"
          >
        </itfg-welcome>
      </div>
    }
  </itfg-d-box>

  <!-- Quick Actions Box -->
  <itfg-d-box
    title="Бързи действия"
    [colSpan]="3"
    *ngxPermissionsOnly="['CALLS_READ']"
    >
    <div class="quick-actions">
      <button
        *ngxPermissionsOnly="['CALLS_READ']"
        mat-button
        class="action-item"
        (click)="navigate('communication/calls-history')"
        >
        <mat-icon>call_log</mat-icon>
        <span>Обаждания</span>
      </button>
      <button
        *ngxPermissionsOnly="['CALLS_ADMIN_READ_ALL']"
        mat-button
        class="action-item"
        (click)="navigate('communication/calls-report')"
        >
        <mat-icon>assessment</mat-icon>
        <span>Обаждания (Справка)</span>
      </button>
    </div>
  </itfg-d-box>
</itfg-dashboard>
